// export const BUILTIN_DOC_TYPES = [DOC_TYPE.INVOICE, DOC_TYPE.RECEIPT] as const
import { StatusNo } from 'config'

import { DocumentGeneral, DocumentGeneralJSON } from './DocumentsGeneral'
import { DocumentInvoiceV2, DocumentInvoiceV2JSON } from './DocumentsInvoiceV2'
import { DocumentBuilder, DocumentBuilderJSON } from './DocumentsOcrBuilder'
import { DocumentOrderForm, DocumentOrderFormJSON } from './DocumentsOrderForm'

export const SERVICE_ID = {
  GENERAL_OCR: 1,
  // INVOICE: 2, // deprecated
  OCR_BUILDER: 3,
  ORDER_FORM: 4,
  INVOICEV2: 5,
} as const

export const DOC_TYPE = {
  INVOICE: '請求書',
  RECEIPT: '領収書',
  ORDER_FORM: '注文書',
  OCR_BUILDER: 'OCR Builder',
  GENERAL_OCR: 'テキスト・表',
} as const

export type ValueOf<T> = T[keyof T]
export type DocType = ValueOf<typeof DOC_TYPE>

export type DocListItem = {
  objectID: string
  documentName: string
  documentType: DocType
  documentTypeName: string
  documentStatusNo: StatusNo
  verifyUserName1: string
  verifyUserName2: string
  verifyUserName3: string
  updateDateTime: string
  updateUserName: string
  insertDateTime: string
  scheduleDocDeletion: string
  subGroup: string
  assigneeName: string
  ocrBuilderConfigID: number
  ocrBuilderTemplateID: number
  isVerify: boolean
  isVerifyRegistered: boolean
}

export type VerifyData = {
  user1: string
  user2: string
  user3?: string
  verifyData: [
    {
      fieldName: string
      id?: string
      user1Data: any
      user2Data: any
      user3Data?: any
    },
  ]
}

export type TDocInfo = {
  objectID: string
  documentName: string
  documentType: DocType
  documentTypeName: string
  documentStatusNo: StatusNo
  prevDocumentStatusNo: number
  fileExt: string
  pageSize: number
  ocrBuilderConfigID: number
  ocrBuilderTemplateID: number
  ocrService: OCRService
  updateDateTime: Date
  subGroup: string
  isVerify: boolean
  isVerifyRegistered: boolean
}

export type OCRService = {
  ocrServiceId: number
  name: string
  version: number
}

export type ConfigItem = {
  display: boolean
  edit: boolean
  verify: boolean
}

export type Config = {
  [key: string]: ConfigItem
}

type Coordinate = [number, number]
export const COORDINATE_KEYS = [
  'top_left',
  'top_right',
  'bottom_right',
  'bottom_left',
] as const
export type Coordinates = {
  [key in (typeof COORDINATE_KEYS)[number]]: Coordinate
}

export type Highlight = {
  name: string
  label: string
  detectedPage: number
  coordinates: Coordinates
}

export type Document =
  | DocumentInvoiceV2
  | DocumentOrderForm
  | DocumentBuilder
  | DocumentGeneral

export type DocumentJSON =
  | DocumentInvoiceV2JSON
  | DocumentOrderFormJSON
  | DocumentBuilderJSON
  | DocumentGeneralJSON

export const TAB_STATUS = {
  BASE: 0,
  ITEMS: 1,
} as const
